import { uploadService } from '@/api/services/upload.service';

export const state = () => ({
    infoImage: null,
    infoVideo: null
});

export const getters = {
    infoImage: (state) => state.infoImage,
    infoVideo: (state) => state.infoVideo
};

export const actions = {
    acUploadImage({ dispatch, commit }, data) {
        return uploadService.uploadImage(data).then(
            (data) => {
                commit('handleUploadImage', data.data);
                return data;
            },
            (error) => {
                commit('errorUploadImage', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    acUploadVideo({ dispatch, commit }, data) {
        return uploadService.uploadVideo(data).then(
            (data) => {
                commit('handleUploadVideo', data.data);
                return data;
            },
            (error) => {
                commit('errorUploadVideo', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    acgetJobStatusFile({ dispatch }, jobId) {
        return uploadService.getJobStatusFile(jobId).then(
            (data) => {
                return data;
            },
            (error) => {
                dispatch('notification/error', error, { root: true });
                throw error;
            }
        );
    }
};

export const mutations = {
    handleUploadImage(state, data) {
        state.infoImage = data;
    },

    errorUploadImage(state) {
        state.status = {};
        state.infoImage = null;
    },

    handleUploadVideo(state, data) {
        state.infoVideo = data;
    },

    errorUploadVideo(state) {
        state.status = {};
        state.infoVideo = null;
    }
};
